import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.css'],
  standalone: false
})

export class ImportModalComponent implements OnInit {

  GetFileUpload: any;
  @Output() saveEmit = new EventEmitter<string>();
  @Output() uploadEmit = new EventEmitter<string>();
  @Input('title') public title: string | string[] = '';
  @Input('idModal') public idmodal: string | string[] = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

  uploadFile(event: any) {
    this.uploadEmit.emit(event);
  }

  saveFile() {
    this.saveEmit.emit();
    // Blur the Save button first so it no longer holds focus.
    // Bootstrap 5 will then be able to set aria-hidden="true" on the modal
    // without the "Blocked aria-hidden on focused descendant" warning.
    const btn = document.getElementById('buttonSubmitUpload');
    btn?.blur();

    const modalEl = document.getElementById(this.idmodal as string);
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      modal?.hide();
    }
  }

}
